import { Injectable } from '@angular/core';
import { Settings } from 'src/app/app.settings.model';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { AppSettings } from 'src/app/app.settings';
import { ActivatedRoute, Router } from '@angular/router';
import { map } from 'rxjs/operators';
import { CustomerSearchResult } from '../models/customer-search-result';
import { Observable } from 'rxjs';
import { SearchCustomerFilter } from '../interfaces/search-customer-filter';
import { Utils } from '../utils';

@Injectable({
  providedIn: 'root'
})
export class SearchCustomerService {

  settings: Settings;
  apiEndPoint: string =  Utils.getApiEndPoint(); // environment.APIEndpoint;

  constructor(
    private http: HttpClient,
    private appSettings: AppSettings,
    private route: ActivatedRoute,
    public router: Router
  ) {
    this.settings = appSettings.settings;
  }


  search(data: SearchCustomerFilter): Observable<CustomerSearchResult[]> {
    // console.log(data.FilterText);
    return this.http.post<any>(this.apiEndPoint + `CustomerApi/Search`, data)
      .pipe(map(response  => {
        return response;
      }));
  }
}
